<iw-expose-preview
  *ngIf="globalObjectKey"
  (load)="onLoad()"
  (error)="onError($event)"
  identifier="{{ globalObjectKey }}"></iw-expose-preview>
